<template>
  <section class="my-0">
    <div class="row mb-3 mx-1 d-flex py-0 my-0 justify-content-end">
      <div
        class="col-sm-5 col-md-12 col-lg-8 col-xl-7 py-1 px-1 text-primary text-left"
      >
        <div class="row justify-content-end" v-if="!isDisable">
          <div class="col-12 d-flex justify-content-end align-items-center">
            <strong class="pt-2 h6">
              <span v-if="!apollo.total_result"> 0 </span>
              <span v-else>
                {{
                  $t("lang.onBoarding.prospects", {
                    prospects: new Intl.NumberFormat("es-ES").format(
                      apollo.total_result
                    ),
                  })
                }}
              </span>
            </strong>
            <span class="mx-2 h4 pb-0">|</span>
            <img
              :src="imgGraphic"
              width="22px"
              height="31px"
              class="pb-2 img-business"
              alt="business image"
            />
            <div class="text-left ml-2 mt-2 pb-2">
              <div class="text-dark font-size-10">
                <strong>{{ statusText }}</strong>
                <Tooltip class="ml-2" :text="messageToolTip" :width="''">
                  <div
                    class="mt-1 circle bg-secondary d-flex align-items-center justify-content-center"
                  >
                    <div class="question-mark text-white">?</div>
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-else>
          <div class="col-12">
            <span
              v-if="reloading"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div>
        
        <ContactPreview
          :key="contactkey"
          :contacts="apollo.people"
          v-if="apollo.total_result > 0 && !reloading"
        />
        <LoadingSpinner v-if="reloading" />
        <span v-if="apollo.total_result == 0 && !reloading"> No contacts</span>
      </div>
    </div>
    <div class="row" v-if="apollo.total_result > 0">
      <div class="col-12 text-center mt-4">
        <button
          class="btn btn-primary btn-sm"
          @click="getMyApollo(target.data)"
        >
          {{ $t("lang.orders.refresh_contacts") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import ContactPreview from "@/components/Contacts/ContactPreview.vue";
import { mapState, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import { proporsalService } from "@/_services";

export default {
  data() {
    return {
      reloading:true,
      valueUpdated: true,
      text2: "",
      apollo: {
        total_result:0,
        people:[]
      },
      isDisable: true,
      people:[],
    };
  },
  computed: {
    ...mapState({
      //apollo: state => state.onboarding.apollo,
      //isDisable: state => state.onboarding.isDisable
      categories_jobs_group: (state) =>
        state.optionsList.all["category_jobs_group"].data,
    }),
    statusText() {
      if (this.apollo.total_result < 3000) {
        return "Too small";
      } else if (this.apollo.total_result < 10000) {
        return "Good";
      } else {
        return "Great!";
      }
    },
    imgEmoticon() {
      if (this.apollo.total_result < 3000) {
        return require("@/assets/images/too_small_emoticon.png");
      } else if (this.apollo.total_result < 10000) {
        return require("@/assets/images/ok.png");
      } else {
        return require("@/assets/images/start.png");
      }
    },
    imgGraphic() {
      if (this.apollo.total_result < 3000) {
        return require("@/assets/images/too_small.png");
      } else if (this.apollo.total_result < 10000) {
        return require("@/assets/images/good.png");
      } else {
        return require("@/assets/images/great.png");
      }
    },
    messageToolTip() {
      if (this.apollo.total_result < 5000) {
        return this.$t("lang.orders.too_low");
      } else if (this.apollo.total_result < 10000) {
        return this.$t("lang.orders.good");
      } else {
        return this.$t("lang.orders.great");
      }
    },
  },

  created() {

    this.categoryJobs = JSON.parse(JSON.stringify(this.categoryJobs));

    this.reloading = true;
    if (this.simplify) {
      //console.log(this.contacts);
      this.apolloData(this.contacts);
    } else {
      if (
        this.target.data.categories_select != undefined &&
        this.target.data.categories_select.length > 0
      ) {
      
        this.getAudience(this.target.data);
      } else {
      
        this.getAudience(this.target.data);
      }
    }
   
  },

  methods: {
    ...mapActions("onboarding", {
      apolloData: "apolloData",
      getApollo: "getApollo",
    }),
    getMyApollo(data) {
      
     
  
      //data.employess = this.employess
      proporsalService.getApollo(data).then((res) => {
        if (
          data.categories_select !== undefined &&
          data.categories_select.length > 0
        ) {
        
          this.apollo.total_result += res.pagination.total_entries;
      
          this.people = this.people.concat(
            res.people.map((el) => {
              let city_country = "";

              if (el.city !== undefined && el.city !== null) {
                city_country += el.city;
              }
              if (el.photo_url === null || el.photo_url === undefined) {
                el.photo_url = require("@/assets/images/user.png");
              }

              if (el.country !== undefined && city_country !== "") {
                city_country += ", " + el.country;
              } else {
                city_country += el.country;
              }

              return {
                ...el,
                city_country: city_country !== null ? city_country : "",
                website:
                  el.organization && el.organization.website_url
                    ? el.organization.website_url
                    : "",
              };
            })
          );
  
          const array = [...this.people];
          array.sort(() => Math.random() - 0.5);
          this.people = array;
          this.apollo.people = this.people.slice(0, 10);
          
        } else {
          let contacts = res.people.concat(res.contacts);
          contacts.map((el) => {
            let city_country = "";

            if (el.city != undefined && el.city != null) {
              city_country += el.city;
            }
            if (el.photo_url == null || el.photo_url == undefined) {
              el.photo_url = require("@/assets/images/user.png");
            }

            if (el.country != undefined && city_country != "") {
              city_country += ", " + el.country;
            } else {
              city_country += el.country;
            }
            el.city_country = city_country;
            el.website =
              el.organization && el.organization.website_url
                ? el.organization.website_url
                : "";
              let array = [];
              array =  contacts;
            this.apollo.people = array;
            let total =res.pagination.total_entries
            this.apollo.total_result = total;
            //console.log(this.apollo)
            //console.log('city_country--------', el.organization && el.organization.website_url ? el.organization.website_url : '');
          });
        }

  
    
      
       this.reloading = false;
       
      });
    },
    getAudience(data) {
      let targetJobs = data.categories_jobs;
    
      if (
        data.categories_select !== undefined &&
        data.categories_select.length > 0
      ) {
        this.apollo.totalResult = 0;
        data.categories_select.forEach(async (el) => {
          targetJobs.anyof = [];
          
          let values = this.categories_jobs_group[el-1].words.split(",");
          values.forEach((element) => {
            targetJobs.anyof.push({ word: element.replace(/[\r\n]+/g, "") });
          });
          data.categories_jobs = targetJobs;
          let apollo = await this.getMyApollo(data);
        });
      
      }else{
        let targetJobs = data.categories_jobs;
        targetJobs = this.categoryJobs
        data.categories_jobs = targetJobs;
      
        this.getMyApollo(data)
        this.isDisable = false;
      }

         setTimeout(()=>{
              this.reloading = false; 
                   
          },15000)
          this.isDisable = false;
    },
  },

  props: {
    contacts: {},
    contactkey: Number,
    simplify: {
      default: false,
      type: Boolean,
    },
    target: {
      type: Object,
      required: true,
      default: () => {},
    },
    employess:{
      type:Object,
      required:true
    },
    categoryJobs:{
      type:Object ,
      require:true
    }

  },
  components: { ContactPreview, LoadingSpinner, Tooltip },
};
</script>
<style scoped>
.circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 10px;
}
.font-size-10 {
  font-size: 10px;
}

.border-color-gray {
  border-left: 1px solid gray;
}
</style>
